import React, { useState, useEffect } from "react";
import {
  Layout, Button, Form, Select, DatePicker, Row, Col, Input, message, Breadcrumb
} from "antd";
import { useNavigate } from "react-router-dom";
import Headerdiv from "../../layout/header";
import Footerdiv from "../../layout/footer";
import { ShoppingCartOutlined, ArrowLeftOutlined, SaveOutlined, HomeOutlined } from "@ant-design/icons";
import api from "../../../services/axiosInstance";
import dayjs from "dayjs";
import "../../../styles/fluidDesign.css";

const { Content } = Layout;
const { Option } = Select;
const { TextArea } = Input;

const CreatePR = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(false);

  // Load Active Suppliers list
  useEffect(() => {
    const loadSuppliers = async () => {
      try {
        const resSups = await api.get("/masterdropdown/listof_activesuppliers.php");
        if (resSups.data && resSups.data.status === "success") {
          setSuppliers(resSups.data.dataset);
        }
      } catch (error) {
        message.error("Failed to load suppliers.");
      }
    };
    loadSuppliers();
  }, []);

  const handleCreate = async (values) => {
    setLoading(true);
    const payload = {
      sup_id: values.sup_id,
      pr_date: dayjs().format("YYYY-MM-DD"),
      delivery_expected_date: values.delivery_expected_date ? values.delivery_expected_date.format("YYYY-MM-DD") : null,
      ipo_note: values.ipo_note || "",
      items: []
    };

    try {
      const res = await api.post("/inventory/pr/create.php", payload);
      if (res.data && res.data.status === "success") {
        message.success("Purchase Request created successfully.");
        navigate(`/inventory/pr/${res.data.pr_id}/items`);
      } else {
        message.error(res.data.message || "Failed to create Purchase Request.");
      }
    } catch (error) {
      message.error("Error creating Purchase Request.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout className="fluid-page">
      <Headerdiv />

      <div className="fluid-page-header">
        <div className="floating-shape shape-1"></div>
        <div className="floating-shape shape-2"></div>
        <Row align="bottom" justify="space-between">
          <Col>
                          <Breadcrumb
                  className="fluid-breadcrumb"
                  items={[
                      { href: '/dash', title: <HomeOutlined /> },
                      { href: '/inventory-items', title: 'Inventory' },
                      { title: 'Create PR' },
                  ]}
              />
            <h1 className="fluid-page-title">
              <ShoppingCartOutlined /> Create Purchase Request
            </h1>
          </Col>
          <Col xs={0} md={12} style={{ textAlign: 'right' }}>
            <p className="fluid-page-subtitle">Set up a new purchase request with supplier details</p>
          </Col>
        </Row>
      </div>

      <Content className="fluid-content" style={{ display: "flex", justifyContent: "center" }}>
        <div className="fluid-card" style={{ width: "100%", maxWidth: "700px" }}>
          <div className="fluid-card-header">
            <h3 className="fluid-card-title">
              <SaveOutlined style={{ marginRight: 8, color: "var(--fluid-primary)" }} />
              PR Details
            </h3>
          </div>
          <Form
            form={form}
            layout="vertical"
            onFinish={handleCreate}
          >
            <Form.Item
              name="sup_id"
              label={<span style={{ fontWeight: 500, color: "var(--fluid-text)" }}>Select Supplier</span>}
              rules={[{ required: true, message: "Please select a supplier" }]}
            >
              <Select allowClear
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => {
                  const label = option?.label || option?.children;
                  if (Array.isArray(label)) {
                    return label.join('').toLowerCase().includes(input.toLowerCase());
                  }
                  return String(label || '').toLowerCase().includes(input.toLowerCase());
                }}
                placeholder="Choose supplier..."
              >
                {suppliers.map(sup => (
                  <Option key={sup.value} value={sup.value}>{sup.label}</Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              name="delivery_expected_date"
              label={<span style={{ fontWeight: 500, color: "var(--fluid-text)" }}>Expected Delivery Date</span>}
            >
              <DatePicker
                style={{ width: "100%" }}
                disabledDate={(current) => current && current < dayjs().startOf('day')}
              />
            </Form.Item>

            <Form.Item
              name="ipo_note"
              label={<span style={{ fontWeight: 500, color: "var(--fluid-text)" }}>PR Description / Note (Optional)</span>}
            >
              <TextArea rows={4} placeholder="Enter any specific delivery notes, purchase terms, or reference details..." />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0, marginTop: 24 }}>
              <Row gutter={12}>
                <Col span={12}>
                  <Button
                    icon={<ArrowLeftOutlined />}
                    onClick={() => navigate("/inventory-purchase-requests")}
                    block
                  >
                    Back to List
                  </Button>
                </Col>
                <Col span={12}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    icon={<SaveOutlined />}
                    loading={loading}
                    className="fluid-btn-primary"
                    block
                  >
                    Save &amp; Add Items
                  </Button>
                </Col>
              </Row>
            </Form.Item>
          </Form>
        </div>
      </Content>
      <Footerdiv />
    </Layout>
  );
};

export default CreatePR;
